// Safari browsers attempt to load an apple-touch-icon if defined. This must be a PNG.
// This icon has been defined as a `"rel=apple-touch-icon"` link tag.
// If this link tag is missing, the browser will attempt to load the icon from the root of the server, i.e. /apple-touch-icon.png
// A proxy route rule has been defined in Akamai to serve this icon, ensuring it is always available (IPD-17056).
const appleTouchIcon = 'https://www.waitrose.com/ecom/assets/favicon/favicon-180x180.png';

export default {
  meta: {
    title: 'Waitrose.com',
    description:
      'Welcome to Waitrose & Partners online store. Browse quality groceries, inspiring recipes and local store information. Picked, packed & delivered with care.',
    head: {
      titleTemplate: '%s | Waitrose & Partners',
      link: [
        {
          rel: 'apple-touch-icon',
          href: appleTouchIcon,
        },
      ],
      meta: [
        {
          name: 'description',
          content:
            'Welcome to Waitrose & Partners online store. Browse quality groceries, inspiring recipes and local store information. Picked, packed & delivered with care.',
        },
        { charset: 'utf-8' },
        { property: 'og:site_name', content: 'Waitrose.com' },
        {
          property: 'og:image',
          content: appleTouchIcon,
        },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:title', content: 'Waitrose & Partners' },
        {
          property: 'og:description',
          content: 'Buy quality groceries and wine from Waitrose & Partners',
        },
        { property: 'og:card', content: 'summary' },
        { property: 'og:site', content: 'Waitrose & Partners' },
        { property: 'og:creator', content: 'Waitrose & Partners' },
        { property: 'og:image:width', content: '114' },
        { property: 'og:image:height', content: '114' },
      ],
    },
  },
};
